// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__3G2WP","requiredAsterisk":"Info_requiredAsterisk__j6_NE"};